import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result, UniqueEntityID } from '@digibricks/domains';
import { Answer } from '../../answer';
import { MatchingCorrectAnswer } from '../../correct-answers';
import { Question } from '../question';
import { QuestionType } from '../../question-type';
import { SingleChoiceQuestion } from '../single-choice-question';
import { MultipleChoiceQuestion } from '../multiple-choice-question';
import { EssayQuestion } from '../essay-question';
import { SubMatchingQuestion } from './sub-matching-question';
import { FillInBlankQuestion } from '../fill-in-blank-question';
import { Score } from '../../score';
export var MatchingQuestion = /*#__PURE__*/function (_Question) {
  _inherits(MatchingQuestion, _Question);

  var _super = _createSuper(MatchingQuestion);

  function MatchingQuestion() {
    _classCallCheck(this, MatchingQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(MatchingQuestion, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "subQuestions",
    get: function get() {
      return this.props.subQuestions;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps) {
      switch (newQuestionProps.type) {
        case QuestionType.SingleChoice:
          return SingleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.MultipleChoice:
          return MultipleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.Essay:
          return EssayQuestion.create(newQuestionProps);

        case QuestionType.FillInBlank:
          {
            return FillInBlankQuestion.createDefault(newQuestionProps);
          }

        case QuestionType.Matching:
          {
            var matchingQuestion = question;
            var answers = matchingQuestion.answers,
                correctAnswers = matchingQuestion.correctAnswers,
                subQuestions = matchingQuestion.subQuestions;
            var matchingQuestionProps = newQuestionProps;
            matchingQuestionProps.answers = answers.map(function (a) {
              return a.clone();
            });
            matchingQuestionProps.correctAnswers = correctAnswers.map(function (a) {
              return a.clone();
            });
            matchingQuestionProps.subQuestions = subQuestions.map(function (q) {
              return q.clone();
            });
            return MatchingQuestion.create(matchingQuestionProps);
          }
      }
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MatchingQuestion.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        })
      });
    }
  }, {
    key: "addNewAnswer",
    value: function addNewAnswer(answer) {
      if (!answer) {
        return new BadInputError('Answer cannot be null');
      }

      this.props.answers = [].concat(_toConsumableArray(this.props.answers), [answer]);
      return Result.ok();
    }
  }, {
    key: "addSubQuestion",
    value: function addSubQuestion(subQuestion) {
      if (!subQuestion) {
        return new BadInputError('Sub question cannot be null');
      }

      this.props.subQuestions = [].concat(_toConsumableArray(this.props.subQuestions), [subQuestion]);
      this.props.nextIndex = this.props.nextIndex + 1;
      return Result.ok();
    }
  }, {
    key: "addNewCorrectAnswer",
    value: function addNewCorrectAnswer(correctAnswer) {
      if (!correctAnswer) {
        return new BadInputError('Answer cannot be null');
      }

      this.props.correctAnswers = [].concat(_toConsumableArray(this.props.correctAnswers), [correctAnswer]);
      return Result.ok();
    }
  }, {
    key: "addNewQuestionAndCorrectAnswer",
    value: function addNewQuestionAndCorrectAnswer(correctAnswer, subQuestion) {
      if (!correctAnswer) {
        return new BadInputError('Answer cannot be null');
      }

      if (!subQuestion) {
        return new BadInputError('Question cannot be null');
      } // Add correct answer and sub question only once
      // The correctAnswer parameter already contains all necessary information


      this.props.correctAnswers = [].concat(_toConsumableArray(this.props.correctAnswers), [correctAnswer]);
      this.props.subQuestions = [].concat(_toConsumableArray(this.props.subQuestions), [subQuestion]); // Removed duplicate correctAnswer creation - it was causing duplicate sub questions when saving

      return Result.ok();
    }
  }, {
    key: "updateAnswerDescription",
    value: function updateAnswerDescription(answerId, description) {
      this.props.answers = _toConsumableArray(this.props.answers).map(function (answer) {
        if (answer.id.toString() === answerId) {
          answer.updateDescription(description);
        }

        return answer;
      });
      return Result.ok();
    }
  }, {
    key: "updateAnswer",
    value: function updateAnswer(answer) {
      this.props.answers.splice(this.props.answers.indexOf(answer), 1, answer);
      return Result.ok();
    }
  }, {
    key: "deleteAnswer",
    value: function deleteAnswer(answerId) {
      var _this = this;

      this.props.answers = this.props.answers.filter(function (answer) {
        return answer.id.toString() !== answerId;
      });
      this.props.correctAnswers = this.props.correctAnswers.map(function (c) {
        return MatchingCorrectAnswer.create({
          answerId: c.answerId === answerId ? _this.props.answers[0].id.toString() : c.answerId,
          subQuestionId: c.subQuestionId,
          score: Score.create(c.score).getValue(),
          index: c.index
        }).getValue();
      });
      return Result.ok();
    }
  }, {
    key: "updateSubQuestion",
    value: function updateSubQuestion(subQuestion) {
      this.props.subQuestions.splice(this.props.subQuestions.indexOf(subQuestion), 1, subQuestion);
      return Result.ok();
    }
  }, {
    key: "deleteSubQuestionAndCorrectAnswer",
    value: function deleteSubQuestionAndCorrectAnswer(subQuestionId) {
      this.props.subQuestions = this.props.subQuestions.filter(function (s) {
        return s.id.toString() !== subQuestionId;
      }).map(function (s, index) {
        return SubMatchingQuestion.create({
          id: s.id.toString(),
          description: s.description,
          index: index
        }).getValue();
      });
      this.props.correctAnswers = this.props.correctAnswers.filter(function (correctAnswer) {
        return correctAnswer.subQuestionId !== subQuestionId;
      }).map(function (c, index) {
        return MatchingCorrectAnswer.create({
          id: c.id.toString(),
          answerId: c.answerId,
          subQuestionId: c.subQuestionId,
          score: Score.create(c.score).getValue(),
          index: index
        }).getValue();
      });
      this.props.nextIndex = this.props.nextIndex - 1 ? this.props.nextIndex - 1 : 1;
      return Result.ok();
    }
  }, {
    key: "updateSubQuestionDescription",
    value: function updateSubQuestionDescription(id, description) {
      this.props.subQuestions = _toConsumableArray(this.props.subQuestions).map(function (s) {
        if (s.id.toString() === id) {
          s.updateDescription(description);
        }

        return s;
      });
      return Result.ok();
    }
  }, {
    key: "updateSubQuestionIndex",
    value: function updateSubQuestionIndex(id, index) {
      this.props.subQuestions = _toConsumableArray(this.props.subQuestions).map(function (s) {
        if (s.id.toString() === id) {
          s.updateIndex(index);
        }

        return s;
      });
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswer",
    value: function updateCorrectAnswer(correctAnswer) {
      this.props.correctAnswers.splice(this.props.correctAnswers.indexOf(correctAnswer), 1, correctAnswer);
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswers",
    value: function updateCorrectAnswers(correctAnswers) {
      var _this2 = this;

      var answerIdsSet = new Set(correctAnswers.map(function (ca) {
        return ca.answerId;
      }));
      var hasSomeAnswerNotExisted = Array.from(answerIdsSet).some(function (id) {
        return !_this2.answers.some(function (a) {
          return a.id.toString() === id;
        });
      });

      if (hasSomeAnswerNotExisted) {
        return new BadInputError('The Correct answers are not existed in answers');
      }

      this.props.correctAnswers = correctAnswers;
      return Result.ok();
    }
  }, {
    key: "updateSubQuestions",
    value: function updateSubQuestions(subMatchingQuestions) {
      this.props.subQuestions = subMatchingQuestions;
      return Result.ok();
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answers) {
      this.props.answers = answers;
      return Result.ok();
    }
  }, {
    key: "createCorrectAnswer",
    value: function createCorrectAnswer() {}
  }, {
    key: "toJsonV2",
    value: function toJsonV2() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(MatchingQuestion.prototype), "toBaseJson", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        }),
        subQuestions: this.subQuestions.map(function (sq) {
          return sq.toJsonObject();
        })
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var basePropsOrError = _get(_getPrototypeOf(MatchingQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.Matching
      });

      return Result.ok(new MatchingQuestion(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "createDefault",
    value: function createDefault(props) {
      var basePropsOrError = _get(_getPrototypeOf(MatchingQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var firstAnswer = Answer.create({
        description: ''
      }).getValue();
      var answers = [firstAnswer];
      var firstSubQuestion = SubMatchingQuestion.create({
        id: new UniqueEntityID().toString(),
        description: '',
        index: 0
      }).getValue();
      var subQuestions = [firstSubQuestion];
      var correctAnswers = [MatchingCorrectAnswer.create({
        answerId: firstAnswer.id.toString(),
        subQuestionId: firstSubQuestion.id.toString(),
        score: Score["default"],
        index: 0
      }).getValue()];
      var score = Score.create(correctAnswers.reduce(function (a, b) {
        return a + b.score;
      }, 0)).getValue();
      return MatchingQuestion.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        score: score,
        answers: answers,
        correctAnswers: correctAnswers,
        subQuestions: subQuestions
      }));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers,
            subQuestions = data.subQuestions;

        var basePropsOrError = _get(_getPrototypeOf(MatchingQuestion), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          var _subQuestions$find;

          return MatchingCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId,
            subQuestionId: c.subQuestionId,
            score: Score.create(c.score).getValue(),
            index: (subQuestions === null || subQuestions === void 0 ? void 0 : (_subQuestions$find = subQuestions.find(function (s) {
              return c.subQuestionId === s.id.toString();
            })) === null || _subQuestions$find === void 0 ? void 0 : _subQuestions$find.index) | 0
          }).getValue();
        }) : [];
        var subQuestionProps = subQuestions ? subQuestions.map(function (s) {
          return SubMatchingQuestion.create({
            id: s.id,
            index: s.index,
            description: s.description
          }).getValue();
        }) : [];
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          type: QuestionType.Matching,
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps.sort(function (a, b) {
            return a.index - b.index;
          }),
          subQuestions: subQuestionProps
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "getCorrectAnswers",
    value: function getCorrectAnswers(question) {
      var correctAnswers = question.correctAnswers.map(function (c) {
        var _question$answers$fin, _question$subQuestion;

        return {
          id: c.id.toString(),
          answerDescription: (_question$answers$fin = question.answers.find(function (a) {
            return a.id.toString() === c.answerId;
          })) === null || _question$answers$fin === void 0 ? void 0 : _question$answers$fin.description,
          answerId: c.answerId,
          correctAnswerScore: c.score,
          subQuestion: (_question$subQuestion = question.subQuestions.find(function (s) {
            return s.id.toString() === c.subQuestionId;
          })) === null || _question$subQuestion === void 0 ? void 0 : _question$subQuestion.description,
          correctAnswerSelection: c.answerId
        };
      });
      return correctAnswers;
    }
  }]);

  return MatchingQuestion;
}(Question);